import React from 'react';
import ReactDOM from 'react-dom';
import "@fontsource/roboto";
import "@fontsource/oswald";
import {
    BrowserRouter as Router,
    Switch,
    Route
} from "react-router-dom";
import history from './history';

import IndexPage from "./components/IndexPage";
import InstructionPage from "./components/InstructionPage";
import SettingsPage from "./components/SettingsPage";
import LoadingPage from "./components/LoadingPage";
import SuccessPage from "./components/SuccessPage";
import ErrorPage from "./components/ErrorPage";


function Landing() {
    return (
        <Router history={history}>
            <div>
                <Switch>
                    <Route path="/error">
                        <ErrorPage/>
                    </Route>
                    <Route path="/success">
                        <SuccessPage/>
                    </Route>
                    <Route path="/loading">
                        <LoadingPage/>
                    </Route>
                    <Route path="/settings">
                        <SettingsPage/>
                    </Route>
                    <Route path="/instruction">
                        <InstructionPage/>
                    </Route>
                    <Route path="/">
                        <IndexPage/>
                    </Route>
                </Switch>
            </div>
        </Router>
    );
}

export default Landing;
if (document.getElementById('app')) {
    ReactDOM.render(<Landing/>, document.getElementById('app'));
}
